import { CITY_CODE_NUMBER } from '@encarpkg/shared';

export const getCarName = (manufacturer, model, badge, badgeDetail) => {
	const nameArr = [manufacturer, model, badge];
	if (badgeDetail) nameArr.push(badgeDetail);
	return nameArr.join(' ');
};

// 특수문자 제거 후 연속된 공백(탭 등 포함)을 하나의 언더바로 치환
export const CharactersChange = (value) =>
	value
		?.replace(/[.*+?^${}()|[\]\\]/g, '')
		.trim()
		.replace(/\s+/g, '_');

// 차종
export const daBodyName = (value) => {
	let result = '';
	if (value === '경차') {
		result = 'ca_Sm';
	} else if (value === '소형차') {
		result = 'ca_Com';
	} else if (value === '준중형차') {
		result = 'ca_Lgt';
	} else if (value === '중형차') {
		result = 'ca_Med';
	} else if (value === '대형차') {
		result = 'ca_Big';
	} else if (value === '스포츠카') {
		result = 'ca_Spt';
	} else if (value === 'SUV') {
		result = 'ca_SUV';
	} else if (value === 'RV') {
		result = 'ca_RV';
	} else if (value === '경승합차') {
		result = 'ca_Type1';
	} else if (value === '승합차') {
		result = 'ca_Type2';
	} else if (value === '화물차') {
		result = 'ca_Type3';
	}
	return result;
};

// 가격 구간
export const daPrice = (value) => {
	let result;
	if (value < 500) {
		result = 'PM0';
	} else if (value < 1000) {
		result = 'PM500';
	} else if (value < 1500) {
		result = 'PM1000';
	} else if (value < 2000) {
		result = 'PM1500';
	} else if (value < 2500) {
		result = 'PM2000';
	} else if (value < 3000) {
		result = 'PM2500';
	} else if (value < 3500) {
		result = 'PM3000';
	} else if (value < 4000) {
		result = 'PM3500';
	} else if (value < 4500) {
		result = 'PM4000';
	} else if (value < 5000) {
		result = 'PM4500';
	} else {
		result = 'PM5000';
	}
	return result;
};

// 주행거리 구간
export const mileageSection = (mileage) => {
	let section = '';

	if (mileage < 20000) section = 'section1';
	else if (mileage < 40000) section = 'section2';
	else if (mileage < 60000) section = 'section3';
	else if (mileage < 80000) section = 'section4';
	else if (mileage < 100000) section = 'section5';
	else section = 'section6';

	return section;
};

export const getCityCodeNumber = (sido) => {
	if (!sido) return '';
	return CITY_CODE_NUMBER[sido] ? CITY_CODE_NUMBER[sido] : '';
};

export default null;
